export const SET_ERRORS = 'errors/SET_ERRORS'
export const CLEAR_ERRORS = 'errors/CLEAR_ERRORS'
